import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

/* Weiterleitung alter (WordPress-)URLs auf die passendste aktuelle Seite.
   Statisches SPA-Hosting kann kein echtes HTTP-301 – daher prerenderte Seite mit
   canonical auf das Ziel (Signal-Konsolidierung für Suchmaschinen) plus clientseitiger
   Weiterleitung für Besucher. Kein noindex, damit die Signale auf die Zielseite übergehen. */
const BASE = "https://dimedial.studio";

export default function AltWeiterleitung({ ziel, titel }) {
  useEffect(() => { window.location.replace(ziel); }, [ziel]);
  return (
    <>
      <Helmet>
        <title>{`${titel} | DIMEDIAL`}</title>
        <meta name="description" content={`Diese Seite ist umgezogen. Weiter zu ${titel}.`} />
        <link rel="canonical" href={`${BASE}${ziel}`} />
      </Helmet>
      <main className="min-h-[60vh] grid place-items-center px-6 text-center" data-testid="alt-weiterleitung">
        <div className="max-w-md">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#4A4A4A]">Diese Seite ist umgezogen</p>
          <h1 className="mt-3 text-2xl font-extrabold text-[#111]">Weiter zu {titel}</h1>
          <p className="mt-3 text-[#4A4A4A]">Du wirst automatisch weitergeleitet.</p>
          <p className="mt-5"><a href={ziel} className="inline-flex rounded-full bg-[#111] text-white px-5 py-2.5 text-sm font-bold" data-testid="alt-weiterleitung-link">Jetzt weiter</a></p>
        </div>
      </main>
    </>
  );
}
